<template>
    <v-expansion-panels class="mb-4" v-model="expansionPanel">
        <v-expansion-panel>
            <v-expansion-panel-header> Filtri </v-expansion-panel-header>
            <v-expansion-panel-content>
                <v-dialog ref="dialog" v-model="modal" persistent width="290px">
                    <v-date-picker
                        v-model="filters.date_range"
                        scrollable
                        range
                    >
                        <v-btn text color="primary" @click="modal = false">
                            OK
                        </v-btn>
                    </v-date-picker>
                </v-dialog>

                <v-row v-if="showShops">
                    <v-col md="4" sm="5" xs="12">
                        <v-select
                            v-model="filters.shopId"
                            :items="shops"
                            dense
                            item-value="id"
                            item-text="description"
                            label="Negozi"
                        ></v-select>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col md="2" sm="5" xs="12">
                        <v-select
                            :items="periods"
                            v-model="filters.period"
                            label="Periodo"
                            item-text="description"
                            item-value="id"
                            @change="onChangePeriod"
                        >
                        </v-select>
                        <v-row
                            align="center"
                            justify="space-around"
                            v-if="filters.date_range.length == 2"
                        >
                            <v-col>
                                {{ filters.date_range[0] }} <br />
                                {{ filters.date_range[1] }} <br />
                            </v-col>
                            <v-col>
                                <a href="#" @click="modal = true">modifica</a>
                            </v-col>
                        </v-row>
                        <v-radio-group
                            v-if="enableFieldType"
                            v-model="filters.fieldType"
                            @change="
                                $emit('changeFieldType', filters.fieldType)
                            "
                        >
                            <v-radio
                                :label="'Prezzo'"
                                :value="'prezzo'"
                            ></v-radio>
                            <v-radio
                                :label="'Quantita'"
                                :value="'qty'"
                            ></v-radio>
                        </v-radio-group>
                        <v-checkbox
                            v-if="showErrors"
                            v-model="filters.hide_errors"
                            :true-value="true"
                            label="Nascondi Errori"
                        ></v-checkbox>
                        <v-text-field
                            v-if="showAvgSell"
                            label="Soglia vendite med."
                            type="number"
                            v-model="filters.avg_sell"
                            step="0.1"
                        ></v-text-field>
                    </v-col>
                    <v-col>
                        <v-row>
                            <v-col md="6" sm="5" xs="12">
                                <v-autocomplete
                                    clearable
                                    :items="suppliers"
                                    v-model="filters.selectedSupplier"
                                    label="Fornitori"
                                    :loading="isLoading"
                                    :search-input.sync="search"
                                    hide-no-data
                                    hide-selected
                                    allow-overflow
                                    no-filter
                                    item-text="an_descr1"
                                    item-value="an_conto"
                                    prepend-icon="mdi-database-search"
                                >
                                </v-autocomplete>
                            </v-col>
                            <v-col v-if="showSingleArticleFilter" md="2" sm="6" xs="12">
                                <v-text-field
                                    clearable
                                    label="Codice Articolo"
                                    v-model="filters.codProdotto"
                                ></v-text-field>
                            </v-col>
                            <v-col v-if="showSingleArticleFilter" md="2" sm="5" xs="12">
                                <v-text-field
                                    clearable
                                    label="Cod. Art. Fornitore"
                                    v-model="filters.codArtForn"
                                ></v-text-field>
                            </v-col>
                            <v-col v-if="showSingleArticleFilter"md="2" sm="5" xs="12">
                                <v-text-field
                                    clearable
                                    label="Codice a barre"
                                    v-model="filters.barcode"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col md="4" sm="6" xs="12">
                                <v-autocomplete
                                    clearable
                                    :items="families"
                                    @change="changeFamilySelect('family')"
                                    v-model="filters.selectedFamily"
                                    label="Famiglie"
                                    multiple
                                    small-chips
                                    deletable-chips
                                >
                                </v-autocomplete>
                            </v-col>
                            <v-col md="4" sm="6" xs="12">
                                <v-autocomplete
                                    clearable
                                    :items="subfamilies"
                                    @change="changeFamilySelect('subfamily')"
                                    v-model="filters.selectedSubFamily"
                                    label="Sotto Famiglie"
                                    multiple
                                >
                                </v-autocomplete>
                            </v-col>
                            <v-col md="2" class="text-center">
                                <v-btn
                                    depressed
                                    color="primary"
                                    @click="$emit('searchPressed', filters)"
                                >
                                    Cerca
                                    <v-icon right dark> mdi-magnify </v-icon>
                                </v-btn>
                            </v-col>
                            <v-col md="2" class="text-center">
                                <v-btn depressed @click="resetFilter">
                                    Reset
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
</template>
<script>
import requests from "../requests";
import _ from "lodash";
export default {
    name: "sell-product-filters-component",
    props: {
        enableFieldType: {
            type: Boolean,
            default: true,
        },
        showErrors: {
            type: Boolean,
            default: false,
        },
        showAvgSell: {
            type: Boolean,
            default: false,
        },
        preselectFamily: {
            type: Boolean,
            defalt: false,
        },
        showShops: {
            type: Boolean,
            default: false,
        },
        showSingleArticleFilter: {
            type: Boolean,
            default: true,
        },
    },
    watch: {
        search(val) {
            //if (this.suppliers.length > 0) return
            // Items have already been requested

            if (this.filters.selectedSupplier != null) return;

            if (this.isLoading) return;

            this.isLoading = true;
            requests
                .getSuppliers(val)
                .then((res) => {
                    this.suppliers = res.data;
                })
                .finally(() => (this.isLoading = false));
        },
    },
    data: () => {
        return {
            search: null,
            families: [],
            subfamilies: [],
            suppliers: [],
            isLoading: false,
            modal: false,
            shops: [],
            user: null,
            expansionPanel: 0,
            periods: [
                {
                    id: "last_week",
                    description: "Ultima settimana",
                },
                {
                    id: "last_month",
                    description: "Ultimo mese",
                },
                {
                    id: "last_three_months",
                    description: "Ultimi 3 mesi",
                },
                {
                    id: "last_six_months",
                    description: "Ultimi 6 mesi",
                },
                {
                    id: "last_year",
                    description: "Ultimo anno",
                },
                {
                    id: "custom",
                    description: "Custom",
                },
            ],
            filters: {
                fieldType: "prezzo",
                period: "last_week",
                hide_errors: true,
                avg_sell: 0.5,
                date_range: [],
                selectedFamily: [],
                shopId: null,
            },
        };
    },
    mounted() {
        this.user = window.currentUser;
        this.getFamilies();
        if (this.showShops) this.getShopList();
    },
    methods: {
        getShopList() {
            const casaMadre = {
                id: -1,
                tb_codstab: 2,
                tb_seriedef: "1",
                us_magazzino: 103,
                us_regddt: "",
                description: "CASA MADRE",
                type: "shop",
                address: null,
                city: null,
                cap: null,
                region: null,
                location: null,
                shop_type: "J",
                metri_quadri: 130,
                codice_franchise: null,
                lotto_riordino_reference: 0,
                lotto_riordino: 0,
            };
            requests.getShopList().then((res) => {
                if (this.user && this.user.role === "Admin") {
                    // Admin can see all shops
                    this.shops = res.data;
                } else if (this.user && this.user.shop_owner) {
                    // Shop owner can only see their own shop
                    this.shops = res.data.filter(shop => shop.us_magazzino === this.user.shop_owner);
                } else {
                    // Default behavior - show all shops (fallback)
                    this.shops = res.data;
                }
                
                // this.shops.push(casaMadre);
                if (this.shops.length > 0) {
                    this.filters.shopId = this.shops[0].id;
                }
                this.$emit("shopLoaded", this.filters);
            });
        },
        changeFamilySelect(type) {
            if (type == "family" && this.filters.selectedFamily.length > 0) {
                this.getSubFamilies(this.filters.selectedFamily);
            }
        },
        getFamilies() {
            let tmp = [];
            requests.getFamilies().then((res) => {
                res.data.forEach((val) => {
                    let obj = {
                        text: val.ACL_DESCLA1,
                        value: val.ACL_CODCLA1,
                    };
                    tmp.push(obj);
                    if (this.preselectFamily)
                        this.filters.selectedFamily.push(val.ACL_CODCLA1);
                });
                this.families = tmp;

                if (this.preselectFamily)
                    this.getSubFamilies(this.filters.selectedFamily);
            });
        },

        getSubFamilies(fid) {
            let tmp = [];
            requests.getSubFamilies(fid).then((res) => {
                res.data.forEach((val) => {
                    let obj = {
                        text: val.ACL_DESCLA2,
                        value: val.ACL_CODCLA2,
                    };
                    tmp.push(obj);
                });
                this.subfamilies = tmp;
                this.$emit("subfamilyLoaded", this.filters);
            });
        },
        resetFilter() {
            _.forEach(this.filters, (val, key) => {
                this.filters[key] = null;
            });
            this.filters.period = "last_week";
            this.order = {};
        },
        getFilters() {
            return this.filters;
        },
        onChangePeriod() {
            if (this.filters.period == "custom") this.modal = true;
        },
        closeExpansionPanel() {
            this.expansionPanel = null;
        }
    },
};
</script>
